import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { FaBars, FaCog, FaSignOutAlt } from 'react-icons/fa';
import { MdDashboard, MdPerson, MdPeople, MdAddBox, MdMoney, MdLocalHospital, MdLibraryBooks } from 'react-icons/md';
import '../assets/css/mainstyle.css';
import '../assets/css/ClientSidebar.css';
import medocImage from '../assets/images/medocplastics.png';
import logomedtinz from '../assets/images/Bright Web.png';
import logoclinic from '../assets/images/logoclinic.png';
import api from '../service/caller';
import { usePermissions } from '../contexts/PermissionContext';
import { FaLock } from "react-icons/fa";
import { AiTwotoneDashboard } from "react-icons/ai";
import { RiListSettingsLine } from "react-icons/ri";
import { HiMiniUsers } from "react-icons/hi2";
import { GrUserSettings } from "react-icons/gr";
import { AiTwotoneSchedule } from "react-icons/ai";
import { FaMoneyBills } from "react-icons/fa6";
import { ImLab } from "react-icons/im";
import { TbPresentationAnalytics } from "react-icons/tb";
import { RiMedicineBottleFill } from "react-icons/ri";
import { FaBed } from "react-icons/fa6";

const ClientSidebar = () => {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const { hasPermission, loading } = usePermissions();
  const [UserData, setUserData] = useState(null); // Initialiser avec null
  const [role, setRole] = useState('');
  const navigate = useNavigate();

  useEffect(() => {
    const fetchLoggedUserData = async () => {
      try {
        const response = await api.get('api/usersprofile');
        setUserData(response.data);
        setRole(response.data.role?.name);
      } catch (error) {
        console.error("Failed to fetch data");
      }
    };
    fetchLoggedUserData();
  }, []);

  const handlePatientFileRedirect = async () => {
    const patientId = UserData?._id;
    console.log('UserData ID:', patientId);

    if (patientId) {
      try {
        const response = await api.get(`clinic/patientsbyuserid/${patientId}`);
        const patientData = response.data;

        if (patientData && patientData._id) {
          navigate(`/hospitaladmin/patientfilemedical/${patientData._id}`);
        } else {
          console.log("Aucun patient trouvé avec cet ID");
        }
      } catch (error) {
        console.error('Erreur lors de la récupération des données du patient', error);
      }
    } else {
      console.log('Aucun ID d\'utilisateur trouvé');
    }
  };

  const handleLogout = () => {
    localStorage.removeItem('token');
    navigate('/Clientlogin');
  };

  const toggleSidebar = () => setSidebarOpen(!sidebarOpen);

  return (
    <div className={`sidebar-container ${sidebarOpen ? 'open' : 'closed'}`}>
      <div className="sidebar-header">
        <div className='sidebartop d-flex align-items-center'>
          <img src={logoclinic} className='cardicon' alt="Consultation Icon" style={{ width: 'auto', height: '80px' }} />
          <div className='ms-auto'>
            <FaBars onClick={toggleSidebar} className='sidebar-toggle-btn' />
          </div>
        </div>
      </div>

      <div className={`sidebar-menu-container ${sidebarOpen ? 'visible' : 'hidden'}`}>
        <div className="sidebar-menu">
          <ul>
            {role != 'medtinz_client_patient' && (
              <li><Link to="/hospitaladmin/dashboard"><AiTwotoneDashboard className="nav-icon" />Dashboard</Link></li>
            )}

            {role === 'medtinz_client_patient' && (
              <li onClick={handlePatientFileRedirect}><Link><MdPerson className="nav-icon" />Medical history</Link></li>
            )}

            {hasPermission('medtinz_client_hospitals_view') && (
              <li><Link to="/hospitaladmin/hospitalsetting"><RiListSettingsLine className="nav-icon" />Hospital Settings</Link></li>
            )}

            {hasPermission('medtinz_client_patient_view') && (
              <li><Link to="/hospitaladmin/patientlist"><HiMiniUsers className="nav-icon" />Patient Management</Link></li>
            )}

            {hasPermission('medtinz_client_staff_view') && (
              <li><Link to="/hospitaladmin/stafflist"><GrUserSettings className="nav-icon" />Staff Management</Link></li>
            )}

            {hasPermission('medtinz_client_appointment_view') && (
              <li><Link to="/hospitaladmin/Appointmentlist"><AiTwotoneSchedule className="nav-icon" />Appointment Scheduling</Link></li>
            )}

            {hasPermission('medtinz_client_billing_view') && (
              <li><Link to="/Billings/allpaymentlist"><FaMoneyBills className="nav-icon" />Billing</Link></li>
            )}

            {hasPermission('medtinz_client_inventory_pharamacy_view') && (
              <li className="disabled-menu"><Link to=""><RiMedicineBottleFill className="nav-icon" />Inventory and Pharmacy<FaLock className="lock-icon" /></Link></li>
            )}

            {hasPermission('medtinz_client_laboratory_records_view') && (
              <li className="disabled-menu" ><Link to=""><ImLab className="nav-icon" />Laboratory Records<FaLock className="lock-icon" /></Link></li>
            )}

            {/* {hasPermission('medtinz_client_telemedecine_view') && (
              <li><Link to="/hospitaladmin/telemedecine"><MdLibraryBooks className="nav-icon" />Telemedicine</Link></li>
            )} */}

            {hasPermission('medtinz_client_reports_analytics_view') && (
              <li><Link to="/report"><TbPresentationAnalytics className="nav-icon" />Reports and Analytics</Link></li>
            )}

            {hasPermission('medtinz_client_room_view') && (
              <li className="disabled-menu"><Link to="/hospitaladmin/rooms_list"><FaBed className="nav-icon" />Room Management<FaLock className="lock-icon" /></Link></li>
            )}
          </ul>
        </div>
      </div>

      <div className="footersid">
        <div className="footermenu">
          {role != 'medtinz_client_patient' && (
            <h4><FaCog /> <Link to="/hospitaladmin/generalconfig">Settings</Link></h4>
          )}
          <h4 onClick={handleLogout} style={{ cursor: 'pointer' }}><FaSignOutAlt /> Logout</h4>
        </div>
        <div className="footermenu">
          <img src={logomedtinz} className='cardicon' alt="Consultation Icon" style={{ width: '100px', height: '20px' }} />
        </div>
        <div className="blueband">
          <div className='boitemed'>
            <div>
              <img src={medocImage} className='medocfooterimg' alt="Consultation Icon" />
            </div>
            <div>
              {role != 'medtinz_client_patient' && (
                <button className="footersidebtn me-auto">Upgrade plan</button>
              )}
            </div>
          </div>
          <p>The hospital management is facing a shortage of medication</p>
        </div>
      </div>
    </div>
  );
}

export default ClientSidebar;
